// System health dashboard and refresh runs.
import {
  ForgeSystemHealthDashboardResponse,
  ForgeSystemHealthRefreshRequest,
  ForgeSystemHealthRefreshRunResponse,
} from '../../types/systemHealth';
import { forgeRequest } from '../forgeRequest';
import { FORGE_DASHBOARDS_API_URL } from './endpoints';

export async function fetchSystemHealth(
  token: string,
  chainId?: number | null
): Promise<ForgeSystemHealthDashboardResponse> {
  const requestKey = `${token}:${chainId ?? 'all'}`;
  const params = new URLSearchParams();
  if (chainId) params.set('chain_id', String(chainId));
  const query = params.toString();
  return forgeRequest<ForgeSystemHealthDashboardResponse>(
    token,
    `${FORGE_DASHBOARDS_API_URL}/system-health${query ? `?${query}` : ''}`,
    'Error fetching Forge system health dashboard',
    { dedupeKey: ['fetchSystemHealth', requestKey] }
  );
}

export async function createSystemHealthRefreshRun(
  token: string,
  request: ForgeSystemHealthRefreshRequest
): Promise<ForgeSystemHealthRefreshRunResponse> {
  return forgeRequest<ForgeSystemHealthRefreshRunResponse>(
    token,
    `${FORGE_DASHBOARDS_API_URL}/system-health/runs`,
    'Error starting Forge system health refresh',
    { method: 'POST', body: request }
  );
}

export async function fetchSystemHealthRefreshRun(
  token: string,
  runId: string,
  params?: { signal?: AbortSignal }
): Promise<ForgeSystemHealthRefreshRunResponse> {
  return forgeRequest<ForgeSystemHealthRefreshRunResponse>(
    token,
    `${FORGE_DASHBOARDS_API_URL}/system-health/runs/${encodeURIComponent(runId)}`,
    'Error fetching Forge system health refresh',
    { signal: params?.signal }
  );
}
